module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "picker-map column"
  }, [_c('div', {
    staticClass: "map-container auto"
  }), _vm._v(" "), _c('PostalCodeControl', {
    staticClass: "absolute-top-left"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-afeb5228", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-afeb5228!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapView/index.vue
// module id = 860
// module chunks = 0